module.exports = __webpack_public_path__ + "assets/img/yutou_313.67ddceb2.jpg";